export default "__VITE_ASSET__CZDBd2yV__"